import { DrawingTool, DrawingToolType, ShapeConfig } from './drawing-tool';

export class RectangleDrawingTool extends DrawingTool {

    protected readonly TOOL_TYPE: DrawingToolType = DrawingToolType.RECTANGLE;

    public addNewShape(shapeX, shapeY, shapeId, color?: string, parameters?: any) {
        const newShape =
            {
                id: this.generateShapeId(shapeId),
                type: this.TOOL_TYPE,

                fill: this.DEFAULT_FILL_COLOR,
                opacity: this.DEFAULT_OPACITY,
                stroke: color || this.strokeColor,
                strokeWidth: this.strokeWidth,

                height: 0,
                width: 0,

                x: shapeX,
                y: shapeY,
            } as ShapeConfig
        return newShape;
    }

    public onTouchMove(currentShape, currentX, currentY, startX, startY) {

        currentShape.width = currentX - startX
        currentShape.height = currentY - startY

    }

    public onTouchEnd(currentShape, endX, endY, startX, startY) {
        this.onTouchMove(currentShape, endX, endY, startX, startY)
    }

    public resetTool() {
        // this method remains empty for this implementation
    }

}